import moment from "moment";
import { useNavigate } from "react-router-dom";
import "./productDetail.css";

const VersionTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.product_id ? data?.product_id : '--'}</td>
      <td className="table-each-row-data">{data?.company_product_id ? data?.company_product_id : '--'}</td>
      <td className="table-each-row-data">{data?.product_name ? data?.product_name : '--'}</td>
      <td className="table-each-row-data">{data?.vendorDivision?.name ? data?.vendorDivision?.name : '--'}</td>
      {data?.status ? (
        <td className="table-each-row-data table-each-row-data-color-green">
          Active
        </td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}
      <td className="table-each-row-data">
        {data?.productVersion?.updatedBy?.name ? data?.productVersion?.updatedBy?.name : '--'}
      </td>
      <td className="table-each-row-data">
        {data?.updatedAt ? moment(data?.updatedAt).format("DD MMM YYYY, HH:mm A") : '--'}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/product/version-history-detail/${data?.id}`)
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default VersionTableData;
